import { useGetNotesQuery } from "./notesApiSlice"
import Note from "./Note"
import useAuth from "../../hooks/useAuth"

const NotesList = () => {
    const {username, isManager, isAdmin} = useAuth()
    const {
        data: notes,
        isLoading,
        isSuccess,
        isError,
        error
    // } = useGetNotesQuery(undefined,{ //before it was this and we have removed it bcz it was rerendering again and again inthe network and also to show the subscription name in the redux subscribtion state
    } = useGetNotesQuery('notesList',{
        pollingInterval: 15000, //means every 15 seconds
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    let content

    if (isLoading) content = <p>Loading...</p>

    if (isError) {
        // content = <p className="errmsg">{error?.data?.message}</p>
        content = <p className="errmsg">Error: {error.message}</p>
    }

    if (isSuccess) {
        const { ids, entities} = notes
        // This is added so an employee can only view his asigned notes
        let filteredIds 
        if(isManager || isAdmin) {
            filteredIds = [...ids]
        }else{
            filteredIds = ids.filter(noteId => entities[noteId].username === username)
        }

        const tableContent = ids?.length && filteredIds.map(noteId => <Note key={noteId} noteId={noteId} />)

        // const tableContent = ids?.length
        //     ? ids.map(noteId => <Note key={noteId} noteId={noteId} />)
        //     : null

        content = (
            <table className="table table--notes">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th note__status">Username</th>
                        <th scope="col" className="table__th note__created">Created</th>
                        <th scope="col" className="table__th note__updated">Updated</th>
                        <th scope="col" className="table__th note__title">Title</th>
                        <th scope="col" className="table__th note__username">Owner</th>
                        <th scope="col" className="table__th note__edit">Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
        )
    }

    return content
}
export default NotesList